import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../../../Translations';
import ModalStore from '../../../../../../../../../Modal/Store';
import { LearningDesignResource } from '../../../../../../../../Types';

interface Props {
  learningDesignResource: LearningDesignResource;
  modalStore: ModalStore;
}

const Competencies: React.FC<Props> = ({ learningDesignResource, modalStore }) => (
  <div className="pr-4">
    <h3 className="text-gray-700 text-sm">
      <T kind="Competencies" />
    </h3>
    <div
      className="flex flex-wrap text-teal-600 font-semibold text-lg"
      onClick={modalStore.open}
      data-intercom-target="learning-design-count"
    >
      {learningDesignResource.payload.competencies.length}
    </div>
  </div>
);

export default observer(Competencies);
